import { useEffect, useState } from "react";
import {
  Backdrop, Box, Button, CircularProgress, Grid2 as Grid,
  Stack, Typography, IconButton
} from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import SearchOffIcon from '@mui/icons-material/SearchOff';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, Navigate, useSearchParams } from "react-router-dom";
import moment from "moment";

import TableInv from '../../components/investments/TableInv';
import DetailFileModal from "../../components/modals/DetailFileModal";
import { isEmpty, urlImg } from "../../components/common/helpers";
import { getUser } from "../../actions/users";
import { getPaymentInfo, addInvestment, sendEmailApproval } from "../../actions/investments";

import { useSelector, useDispatch } from "react-redux";

function createData(date, type, monto, status, recibo, metodo, reference, idUsr, file, servicio, servicioEmpresa, factura_pdf, factura_xml, concepto, empresa, extraData) {
  return { date, type, monto, status, recibo, metodo, reference, idUsr, file, servicio, servicioEmpresa, factura_pdf, factura_xml, concepto, empresa, extraData };
}

const DetailInvestment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(state => state.users.user);
  const auth = useSelector(state => state.auth);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);

  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [username, setUsername] = useState("--");
  const [history, setHistory] = useState([]);
  const [monto, setMonto] = useState("0.00");
  const [montoServicios, setMontoServicios] = useState("0.00");
  const [montoFacturas, setMontoFacturas] = useState("0.00");
  const [showModal, setShowModal] = useState(false);
  const [rowSelect, setRowSelect] = useState(null);
  const [hasFetchedRecibo, setHasFetchedRecibo] = useState(false);

  const paymentId = searchParams.get('payment_id');
  //Redirect
  if (!isAuthenticated && isEmpty(paymentId)) {
    return <Navigate to="/" />
  }
  if (user?.datos_empresas.length === 0) {
    return <Navigate to="/home" />
  }

  useEffect(() => {
    if (!hasFetchedRecibo && paymentId && !isEmpty(user)) {
      setHasFetchedRecibo(true);
      obtenerRecibo(paymentId)
        .then(() => {
          const cleanUrl = window.location.pathname;
          window.history.replaceState({}, document.title, cleanUrl);
          setLoading(false);
        })
        .catch(err => {
          console.error("Error al obtener el recibo:", err);
          setLoading(false);
        });
    }
  }, [user]);


  useEffect(() => {
    if (!isEmpty(auth.user)) {
      dispatch(getUser(auth.user?._id));
    }
  }, [auth.user]);

  useEffect(() => {
    if (user) {
      if (isEmpty(paymentId)) {
        setLoading(false);
      }
      setUsername(user?.name ?? "--");
      const rows = [];
      let suma = 0;
      let sumaServicios = 0;
      let sumaFacturas = 0;

      if (user.datos_empresas && user.datos_empresas.length > 0 && !isEmpty(user.datos_empresas[0].inversiones)) {
        user.datos_empresas[0].inversiones.forEach(element => {
          const type = element.tipo ? element.tipo.toLowerCase() : '';

          if (type === 'servicio') {
            if (element.status === 1) {
              sumaServicios += element.monto;
            }
          } else if (type === 'inversión' || type === 'inversion') {
            suma += element.monto;
          } else {
            // Fallback for legacy data
            if (!isEmpty(element.servicio) && element.servicio !== 'null') {
              if (element.status === 1) sumaServicios += element.monto;
            } else {
              suma += element.monto;
            }
          }

          if (element.status === 1 && (!isEmpty(element.factura_pdf) || !isEmpty(element.factura_xml))) {
            sumaFacturas += element.monto;
          }

          let filesUrl = null;
          if (Array.isArray(element.recibo)) {
            filesUrl = element.recibo.map(r => `${urlImg}/inversiones_index_dos/${user._id}/${r}`);
          } else {
            filesUrl = `${urlImg}/inversiones_index_dos/${user._id}/${element.recibo}`;
          }

          rows.push(
            createData(
              element.date, element.tipo, element.monto, element.status, element.recibo, element.metodo,
              element._id, user._id, filesUrl, element.servicio, element.servicioEmpresa,
              element.factura_pdf, element.factura_xml, element.concepto, element.empresa
            )
          );
        });
      }

      if (!isEmpty(user.solicitudes_facturas)) {
        user.solicitudes_facturas.forEach(element => {
          if (element.status === 1 && (!isEmpty(element.factura_pdf) || !isEmpty(element.factura_xml))) {
            sumaFacturas += element.monto;
          }

          rows.push(
            createData(
              element.date,
              'Solicitud Factura',
              element.monto,
              element.status,
              null,
              'solicitud',
              element._id,
              user._id,
              element.comprobante || null,
              null,
              'Solicitud de Factura',
              element.factura_pdf,
              element.factura_xml,
              'Solicitud de Factura',
              null,
              element
            )
          );
        });
      }

      const formatoMonto = suma.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const formatoMontoServicio = sumaServicios.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const formatoMontoFactura = sumaFacturas.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      setMonto(formatoMonto);
      setMontoServicios(formatoMontoServicio);
      setMontoFacturas(formatoMontoFactura);
      setHistory(rows);
    }
  }, [user]);

  const obtenerRecibo = async recibo => {
    const status = searchParams.get('status');
    const servicio = searchParams.get('servicio') || null;
    const res = await getPaymentInfo(recibo);
    if (res) {
      const info = {
        monto: res.additional_info.items[0].unit_price,
        recibo: [res.id],
        metodo: 'mercadopago',
        tipo: servicio === 'null' ? "Inversion" : "Servicio",
        servicio: servicio
      }
      const emailData = {
        subject: 'aprobacion',
        email: user.email,
        nombre: user.name,
        servicio: servicio === 'null' ? false : true
      };
      if (status === 'success') {
        info.status = 1;
        await dispatch(addInvestment(info, user._id, user.datos_empresas[0]._id));
        await sendEmailApproval(emailData);
      }
      return;
    } else {
      console.log("Error al obtener el recibo", info, user._id, user.datos_empresas[0]._id);
      return;
    }
  }

  return (
    <>
      <DetailFileModal
        item={rowSelect}
        visible={showModal}
        cancelCallback={() => setShowModal(false)}
      />
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container mt={{ xs: 10, md: 11 }} spacing={2}>
        <Grid size={12} mt={3}>
          <IconButton sx={{ padding: 0 }} onClick={() => navigate("/inversiones")}>
            <ArrowBackIcon color="primary" sx={{ fontSize: 55, p: 0 }} />
          </IconButton>

        </Grid>
        <Grid className="content-form" size={12} mt={1}>
          <Typography className="titleGray" variant="h2">
            Hola, {username}
          </Typography>
          <Typography className="titleMain" variant="h6">
            Bienvenido a tu dashboard de operaciones
          </Typography>
          <Typography className="subtitleMain">
            Información actualizada al {moment(Date.now()).format("LLLL")}
          </Typography>

          <Stack mt={5} spacing={5}>
            <Grid container alignItems="center" spacing={4}>
              <Grid size={{ xs: 12, md: 4 }} spacing={3} container>
                <Grid size={12}>
                  <Typography className="titleMain" variant="h6">
                    Monto invertido
                  </Typography>
                </Grid>

                <Typography className="titleGray" variant="h1" sx={{ fontSize: 44 }}>
                  ${monto}
                </Typography>

                <Grid size={12}>
                  <Button
                    component="label"
                    role={undefined}
                    className="btn-blue"
                    tabIndex={-1}
                    endIcon={<InsertDriveFileIcon />}
                    onClick={() => navigate("/inversiones")}
                  >
                    Invertir
                  </Button>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12, md: 4 }} spacing={3} container>
                <Grid size={12}>
                  <Typography className="titleMain" variant="h6">
                    Monto en servicios
                  </Typography>
                </Grid>

                <Typography className="titleGray" variant="h1" sx={{ fontSize: 44 }}>
                  ${montoServicios}
                </Typography>

                <Grid size={12}>
                  <Button
                    variant="contained"
                    onClick={() => navigate("/inversiones-con-servicio")}
                  >
                    Contratar servicio
                  </Button>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12, md: 4 }} spacing={3} container>
                <Grid size={12}>
                  <Typography className="titleMain" variant="h6">
                    Monto de facturas de pago por definir
                  </Typography>
                </Grid>

                <Typography className="titleGray" variant="h1" sx={{ fontSize: 44 }}>
                  ${montoFacturas}
                </Typography>

                <Grid size={12}>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#1976D2",
                      "&:hover": {
                        backgroundColor: "#115293"
                      }
                    }}
                    onClick={() => navigate("/solicitar-factura")}
                  >
                    Solicitar Factura
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Stack>

          <Stack mt={10} spacing={5}>
            <div>
              <Typography className="titleSecond" variant="h6">
                Historial
              </Typography>
              <Typography className="subtitleMain" variant="subtitle1">
                Visualiza tus transacciones
              </Typography>
            </div>
            <Box component="section" className="table-investments">
              {
                !isEmpty(history) ? (
                  <TableInv
                    history={history}
                    onSelect={(item) => {
                      setRowSelect(item);
                      setShowModal(true);
                    }}
                    moment={moment}
                  />
                ) : (
                  <Stack className="no-data" alignItems="center" justifyContent="center" spacing={2}>
                    <SearchOffIcon color="disabled" sx={{ fontSize: 40 }} />
                    <Typography className="subtitleMain">
                      Sin datos por mostrar
                    </Typography>
                  </Stack>
                )
              }
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
}

export default DetailInvestment;
